import React from "react";
import DropYardGrid from "./Grid";
import DropYardMap from "./Map";
import { withStyles } from "@material-ui/core";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { withTerminalsHOC } from "../../common/withTerminalsHOC";

const styles = {
  onboardTerminalSubModule: {
    height: "100%",
    display: "flex",
    "&>div": {
      flex: 1,
      boxSizing: "border-box",
    },
    "&>.DropYardForm": {
      width: "20%",
    },
  },
  hideGrid: {
    display: "none",
  },
};

@inject("CommonStore")
@observer
class DropYard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDropYard: [],
      dropYardInfo: null,
      selectedFilter: null,
      isMapMaximized: false,
    };
  }

  dropYardSelectedOnGrid = (dropYard) => {
    this.setState({
      selectedDropYard: dropYard,
    });
  };

  dropYardClickedOnMap = (dropYard) => {
    this.setState({
      selectedDropYard: dropYard ? [dropYard.data] : [],
    });
  };

  selectGridFilter = (option) => {
    if (option.value !== this.state.selectedFilter) {
      this.setState({ selectedFilter: option.value });
    }
  };

  toggleMaximize = () => {
    this.setState((state) => ({
      isMapMaximized: !state.isMapMaximized,
    }));
    this.props.glEventHub.emit("mapResize");
  };

  getTerminalDropYardList = () => {
    const { selectedFilter } = this.state;
    return this.props.CommonStore.dropYardList.filter(
      (dropYard) => dropYard.terminalId === selectedFilter
    );
  };

  render() {
    const { classes, userData, dropYardDataMessage, terminalList } = this.props;
    const { selectedDropYard, dropYardInfo, selectedFilter } = this.state;
    const selectedDropYardId = selectedDropYard?.map(
      (dropYard) => dropYard.dropYardId
    );
    const dropYardList = selectedFilter
      ? this.getTerminalDropYardList()
      : this.props.CommonStore.dropYardList.slice();
    return (
      <div className={classes.onboardTerminalSubModule}>
        {/* For maximizing the map, hide the grid */}
        <div className={this.state.isMapMaximized ? classes.hideGrid : ""}>
          <DropYardGrid
            data={dropYardList}
            error={dropYardDataMessage}
            selectedDropYard={selectedDropYard}
            selectedDropYardId={selectedDropYardId}
            dropYardSelectedOnGrid={this.dropYardSelectedOnGrid}
            selectGridFilter={this.selectGridFilter}
            terminalList={terminalList}
          />
        </div>
        <DropYardMap
          data={dropYardList}
          selectedDropYardId={selectedDropYardId}
          userData={userData}
          dropYardInfo={dropYardInfo}
          dropYardClickedOnMap={this.dropYardClickedOnMap}
          terminalList={terminalList}
          selectedTerminalInFilter={selectedFilter}
          isMapMaximized={this.state.isMapMaximized}
          toggleMaximize={this.toggleMaximize}
          eventHub={this.props.glEventHub}
          CommonStore={this.props.CommonStore}
        />
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile
)(withTerminalsHOC(DropYard));
